module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2000-04-06/3-bc2ee8984111c09c08daf205cb7b024a.jpg";